import gsap, {Linear} from "gsap"
import {Power2} from "gsap"
import * as PIXI from 'pixi.js'
import Config from "@/config/Config";
import { Signals} from "@/Imports";
import Facade from "../../Facade";

export default class GameColumnManager {

    constructor (index, dataField, reelsConfig) {

        this.reelsConfig = reelsConfig

        this.setIndex(index)

        this.shadowFilter = new PIXI.filters.ColorMatrixFilter()
        this.shadowFilter.brightness(0.4, false)
        this.scatters
        this.dataField = dataField
        this.symbols = dataField.allSymbols[index]
        this.easingPower = 1
        this.easing = `back.out(${this.easingPower})` // Bouncing
       // this.pasteSymbolsIntoTempContainer()

      //  Signals.startShowWinnings.add(this.showWinnings, this)
        //Signals.showWinningsComplete.add(this.removeShadow, this)
      //  Signals.startAnimation.add(this.startSingleAnimation, this)
    }

    setIndex(index) {
        this.index = index
        this.timeDownOut = 0.8
        this.delayDownOut = 0.05
        this.startDownY = 0 //800
        this.speed = this.reelsConfig.REELS_SPEED[index]
       // this.startBounce = this.reelsConfig.START_REEL_BOUNCING[this.index]
       // this.stopBounce = this.reelsConfig.STOP_REEL_BOUNCING[this.index]
        this.symbolHeight = this.reelsConfig.SYMBOL_HEIGHT[this.index]
        this.totaSymbolsPerReel = this.reelsConfig.TOTAL_SYMBOLS_PER_REEL[this.index]
        this.visibledSymbols = this.reelsConfig.VISIBLED_SYMBOLS[this.index]
    }

    downSymbolsOnField = async (data, reverse, yStop, timeDownOut, delay, indexColumnDown, EasyType, functionComplete) => {

        return new Promise(resolve => {
            let indexStart = -1
            let needSoundMultiplier = true
            let needSoundScatter = true
            this.symbols.forEach((symbol, index)=>{
                gsap.killTweensOf(symbol)
                if (symbol.y !== yStop + (this.symbolHeight + 1) * index) {
                    if (indexStart === -1){
                        indexStart = index
                    }
                    const ind = reverse ? this.symbols.length - indexStart : indexStart
                    gsap.to(symbol, timeDownOut, { delay: delay * ind, y: yStop + (this.symbolHeight + 1) * index, ease: this.easing,
                        onComplete: ()=>{
                            needSoundMultiplier = this.playSoundScatter(data[index].id, Config.multiplierSymbol, true, needSoundMultiplier)
                            needSoundScatter = this.playSoundMultiplier(data[index].id, Config.scatterSymbol,true, needSoundScatter)
                            symbol.showAnimationStop()
                        }})
                }
            })
            //+ delay * indexColumnDown
            gsap.delayedCall(timeDownOut + delay * this.symbols.length, () => {
                resolve()
            })
        })
    }


    functionDownSymbols2 = async (reverse, yStop, timeDownOut, delay, indexColumnDown, EasyType, functionComplete) => {
        return new Promise(resolve => {
            this.symbols.forEach((symbol, index)=>{
                gsap.killTweensOf(symbol)
                const ind = reverse ? this.symbols.length - index : index
                gsap.to(symbol, timeDownOut, { delay: delay * ind, y: yStop + (this.symbolHeight + 1) * index, ease: this.easing,
                    onComplete: ()=>{}})
            })
            gsap.delayedCall(timeDownOut + delay * indexColumnDown, () => {
                resolve()
            })
        })
    }


    removeSymbol = (index, textureId, multiplier) => {

        let removedSymbol = this.symbols.splice(index, 1)[0];
        removedSymbol.y =  this.symbols[0].y - this.symbolHeight
        if (removedSymbol.y > -200){
            removedSymbol.y = -200
        }

        removedSymbol.changeTextureByIndex(textureId, multiplier)
        //this.dataField.poolIn(removedSymbols)
        this.symbols.unshift(removedSymbol)
    }

    addSymbol = (index) => {
        let removedSymbols = this.symbols.splice(index, 1);
        this.dataField.poolOut(removedSymbols)
    }


    addStopDataSymbols2 = (data) => {

        let s
        for (let i = data.length - 1; i >= 0; i--) {
            let index = data[i]

            //  s = this.poolOut(index, multiplier[i], this.container)
            s = this.dataField.poolOut(index, this.container)
            const indexPlace = (Config.upperSymbols && Config.upperSymbols.includes(index)) ?  1 : 0
            this.symbols[0].parent.addChildAt(s, indexPlace)

            s.y = this.symbols[0].y - (this.symbolHeight + this.reelsConfig.SYMBOL_GAP)
            s.x = this.symbols[0].x
            this.symbols.unshift(s)
        }
        this.sideSymbol = s
    }

    takeOut = async () => {
        this.timeDownOut = 0.7
        this.delayDownOut = 0.04

        await this.functionDownSymbols2( false, 1200,0.7,0.012,
            this.symbols.length - 1, "")
        Signals.columnClearFeelOnDown.dispatch(this.index)
    }

    playSoundScatter(idSymbol, isNewSymbol, needPlay){
        if(idSymbol === Number(Config.scatterSymbol) && isNewSymbol) {
            if (needPlay) {
                console.log(" LAND scatterSymbol " );
                Signals.playScatterLand.dispatch();
                return false
            }
        }
        return true
    }

    playSoundMultiplier(idSymbol, isNewSymbol, needPlay){
        if(idSymbol === Number( Config.multiplierSymbol) && isNewSymbol) {
            if (needPlay) {
                console.log(" LAND multiplierSymbol " );
                Signals.playMultiplierLand.dispatch();
                return false
            }
        }
        return true
    }
    playSoundBigSymbol(idSymbol, symbolBig, isNewSymbol, needPlay){
        if(idSymbol === Number(symbolBig) && isNewSymbol) {
            if (needPlay) {
                console.log(" LAND ",symbolBig );
                Signals.playMultiplierLand.dispatch();
                return false
            }
        }
        return true
    }

    showResult2 = async  (data, anticipation, timeDown = 0.2, deleyColumn = 0.2) => {
        if (anticipation) {
            Signals.startAnticipation.dispatch(this.index);
        }

        await new Promise(resolve => {
            let needSoundMultiplier = true
            let needSoundScatter = true
            this.symbols.forEach((symbol, index) => {
                gsap.killTweensOf(symbol)
                const ind = this.symbols.length - index
                const yPosition = this.startDownY + (this.symbolHeight + 1) * index
                if (symbol.y < yPosition) {
                    gsap.to(symbol, timeDown, { delay: 0.03 * ind, y: yPosition, ease: this.easing,
                   // gsap.to(symbol, timeDown, { delay: deleyColumn, y: yPosition, ease: "",
                        onComplete: ()=> {
                            needSoundMultiplier = this.playSoundMultiplier(data[index].id, data[index].new, needSoundMultiplier)
                            needSoundScatter = this.playSoundScatter(data[index].id, data[index].new, needSoundScatter)
                            symbol.showAnimationStop();
                    }})
                }
            })
            
           // gsap.delayedCall(timeDown + 0.03 * columnIndex, () => {
            gsap.delayedCall(timeDown + deleyColumn, () => {
                resolve()
            })
        })


        // await this.downSymbolsOnField( true, this.startDownY, this.timeDownOut, this.delayDownOut,
        //     this.symbols.length - 1, "back.easeOutBack(0.4)",
        //     () =>{})
    }

    showResult = async  (data, anticipation,  timeDown = 0.2) => {
        if (anticipation) {
            Signals.startAnticipation.dispatch(this.index);
        }
       // Signals.playSymbolDrop.dispatch();
        this.symbols.forEach((symbol, index)=> {
            symbol.y = -1000 + this.symbolHeight * index
            symbol.changeTextureByIndex(data[index].id, data[index].multiplier)
        })
        await this.downSymbolsOnField( data,true, this.startDownY, this.timeDownOut, this.delayDownOut,
            this.symbols.length - 1, "",
            () => {
            })
    }

    pause = async (time) => {
        return new Promise(resolve => {
            gsap.delayedCall(time, () => {
                resolve()
            })
        })
    }

    faster = () => {
        this.timeDownOut = 0.4
        this.delayDownOut = 0.01
    }

    stop3 = async (data) => {
        await this.downSymbolsOnField( data,true, this.startDownY, 0.4,0.01, this.symbols.length - 1)
    }

    stop = async (data, anticipation) => {
        this.symbols.forEach((symbol, index)=> {
            symbol.y = -900 + this.symbolHeight * index
            symbol.changeTextureByIndex(data[index].id, data[index].multiplier)
        })
        await this.downSymbolsOnField(data,true, this.startDownY,0.4,0.01, this.symbols.length - 1)
     //   gsap.to(this.symbols, t, { y: td, onComplete: this.onStopTweenComplete })
    }

    addStopDataSymbols = (data, multiplier) => {

        let s
        for (let i = data.length - 1; i >= 0; i--) {
            let index = data[i]

          //  s = this.poolOut(index, multiplier[i], this.container)
            s = this.dataField.poolOut(index, 1, this.container)
            const indexPlace = (Config.upperSymbols && Config.upperSymbols.includes(index)) ?  1 : 0
            this.symbols[0].parent.addChildAt(s, indexPlace)

            s.y = this.symbols[0].y - (this.symbolHeight + this.reelsConfig.SYMBOL_GAP)
            s.x = this.symbols[0].x
            this.symbols.unshift(s)
        }
        this.sideSymbol = s
    }


    onStopTweenComplete = () => {
        this.playLanding()
        Signals.reelJustTouchDown.dispatch(this.index)
        if (this.stopBounce > 0) {

            this.symbols.map(symbol => symbol.showAnimationStop())
            let time = 0.2
            let td = '-=' + this.stopBounce
            gsap.to(this.symbols, time, { y: td, ease:Power2.easeOut, onComplete: this.onStopSpinningComplete })
        } else {
            this.onStopSpinningComplete()
        }
    }

    onStopSpinningComplete = () => {
        let amount = this.symbols.length - this.totaSymbolsPerReel

        for (let i = 0; i < amount - 1; i++) {
            this.dataField.poolIn(this.symbols.pop())
            this.sideSymbol = this.symbols[this.symbols.length - 1]
        }
        this.dataField.poolIn(this.symbols.pop())
        this.callback(this.index)
    }

    darken(){
        this.symbols.forEach(symbol => {
            symbol.alpha = 1
            symbol.filters = [this.shadowFilter]
        })
    }

    brighten(){
        // gsap.fromTo(this.shadowFilter, 0.5, {alpha: 1, ease: Linear.easeIn, onUpdate: () => {
        //         this.shadowFilter.brightness(1, false)
        //     }, onComplete: () => {}})

        this.symbols.forEach(symbol => {
         symbol.alpha = 1
         symbol.filters = null
        })
    }

    showWinAnimation(index){
        this.symbols[index].alpha = 1
        this.symbols[index].filters = null
        this.symbols[index].win()
    }

    disappear(index){
        //console.log(' disappear  ',index)
        this.symbols[index].disappear()
        gsap.delayedCall(0.5, () => {
            //this.symbols[index].alpha = 0
        })
    }

    applyShadow() {
        //this.container.filters = [this.shadowFilter]
    }

    removeShadow() {
        this.container.filters = null
    }

}
